import Layout from "../../../../components/Layout/Layout";
import BreadCrumb from "../../../../components/BreadCrumb/Breadcrumb";
import Button from "../../../../components/Button/Button";
import { useEffect, useState } from "react";
import useStyles from "../styles";
import useValidator from "../../../../hooks/useValidator";
import { ToastContainer, toast } from "react-toastify";
import SelectGroup from "../../../../components/FormComponent/SelectGroup";
import { Grid, Menu, MenuItem, IconButton, useMediaQuery } from "@mui/material";
import InputGroup from "../../../../components/FormComponent/InputGroup";
import { httprequest } from "../../../../data/api";
import { useParams, useNavigate } from "react-router-dom";
import WidgetTitle from "../../../../components/WidgetTitle/WidgetTitle";
import { Icon } from "@iconify/react/dist/iconify.js";
import TextAreaGroup from "../../../../components/FormComponent/TextAreaGroup";
import PageLoader from "../../../../components/PageLoader/pageloader";
import { useUserState } from "../../../../context/UserContext";
import Select from "react-select";

const ADMIN_CLASS_ENDPOINT = "/admin/v1/classes";
const A_SCHOOL_EXAM = "/admin/v1/school-exams";
const TEACHER_SUBJECT_FOR_CLASS_ENDPOINT = "/api/v1/teacher/class-subject/";
// const ASSIGNMENT_DRAFT = "/api/v1/assignment/draft/";
const UPLOAD_ENDPOINT = "/api/v1/upload";
const CLASS_SUBJECT = "/admin/v1/class-subject/";

const EditSchoolExam = () => {
  const [classData, setClassData] = useState([]);
  const { id, schoolId } = useParams();
  const navigate = useNavigate();
  const styles = useStyles();
  const { userRole } = useUserState();
  const [isLoading, setIsLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isDraftSaving, setIsDraftSaving] = useState(false);
  const [isPublishing, setIsPublishing] = useState(false);
  const [currentAnchor, setCurrentAnchor] = useState("");
  const [disabledInputs, setDisabledInputs] = useState({});
  // const [questionImages, setQuestionImages] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [editEnrolExamValidator, showEditEnrolExamValidator] = useValidator();
  const [totalGrade, setTotalGrade] = useState(0);
  const [allClassSubject, setAllClassSubject] = useState([]);
  const isTeacher = userRole?.role_type === "teacher";

  const handleClick = (event, queInd) => {
    setAnchorEl(event.currentTarget);
    setCurrentAnchor(queInd);
  };
  const handleAdditionalQueClose = () => {
    setAnchorEl(null);
  };

  const isSmallScreen = useMediaQuery("(max-width: 700px)");

  const [editSchoolExam, setEditSchoolExam] = useState({
    title: "",
    class_id: [],
    description: "",
    total_grade: 0,
    instruction: "",
    duration: 0,
    questions: []
  });

  // This creates a new question
  const handleAdditionalQuestion = () => {
    const newQue = {
      question: "",
      question_index: editSchoolExam?.questions?.length + 1,
      type: "",
      answer: [],
      file: {},
      required: false,
      grade_point: "",
      options: []
    };

    setEditSchoolExam((prevForm) => ({
      ...prevForm,
      questions: [...(prevForm.questions || []), newQue]
    }));
  };

  // --| Remove additional choice added as an option in a question
  const removeAdditionalChoice = (index, queInd) => {
    const newQueArr = [...editSchoolExam.questions];
    const newChoiceArr = newQueArr[queInd]["options"]?.filter(
      (_item, ind) => ind !== index
    );
    newQueArr[queInd]["options"] = newChoiceArr;
    setEditSchoolExam({ ...editSchoolExam, questions: newQueArr });
  };

  // THis handle choice select
  const handleMultipleChoiceChange = (e, index, queInd) => {
    const { value } = e.target;

    const options = editSchoolExam.questions[queInd]["options"];
    const newOptionArr = [...options];

    newOptionArr[index] = value;
    const newQueArr = [...editSchoolExam.questions];
    newQueArr[queInd]["options"] = newOptionArr;
    setEditSchoolExam({ ...editSchoolExam, questions: newQueArr });
  };

  const calculateTotalGrade = () => {
    if (!Array.isArray(editSchoolExam.questions)) {
      setTotalGrade(0);

      return;
    }
    const total = editSchoolExam.questions.reduce((sum, question) => {
      return sum + (parseFloat(question.grade_point) || 0);
    }, 0);
    setTotalGrade(total);
  };

  const removeQueDescription = (index) => {
    const newQuestionArr = [...editSchoolExam.questions];
    delete newQuestionArr[index]["description"];
    setEditSchoolExam({ ...editSchoolExam, questions: newQuestionArr });
  };

  // Edit Correct Option Check of a Specific Question
  const handleCorrectChoiceChange = (e, optionIndex, queInd) => {
    const newQuestionArr = [...editSchoolExam.questions];

    // Check the type for the specific question based on (queInd)
    if (newQuestionArr[queInd]?.type === "multiple_choice") {
      // Update the state with the new questions array
      newQuestionArr[queInd]["answer"] = [optionIndex];
    } else if (newQuestionArr[queInd]?.type === "checkbox") {
      // For checkbox ( one or multiple correct answers allowed)
      const answers = newQuestionArr[queInd]["answer"] || [];

      if (e.target.checked) {
        // Add the option index if checked
        answers.push(optionIndex);
      } else {
        // Remove the option index if unchecked
        const answerIndex = answers.indexOf(optionIndex);
        if (answerIndex > -1) {
          answers.splice(answerIndex, 1);
        }
      }

      // Update answer in the question array
      newQuestionArr[queInd]["answer"] = answers;
    }

    // Set the updated questions array
    setEditSchoolExam({ ...editSchoolExam, questions: newQuestionArr });
  };

  // This adds an additional option to a specific question
  const handleAdditionalOptions = (queInd) => {
    const updatedQuestions = [...editSchoolExam.questions];

    updatedQuestions[queInd].options = [...updatedQuestions[queInd].options, [" "]];

    setEditSchoolExam({
      ...editSchoolExam,
      questions: updatedQuestions
    });
  };

  // This Updates the value a specific question based on user input.
  const handleQueTypeChange = (e, index) => {
    const { name, value } = e.target;
    const updatedQuestions = [...editSchoolExam.questions];
    updatedQuestions[index][name] = value;
    if (updatedQuestions[index].options.length === 0) {
      handleAdditionalOptions(index);
    }

    setEditSchoolExam({
      ...editSchoolExam,
      questions: updatedQuestions
    });
  };

  const toggleQueDescriptionTrue = () => {
    const updatedQuestions = [...editSchoolExam.questions];
    updatedQuestions[currentAnchor]["description"] = "";
    setEditSchoolExam({
      ...editSchoolExam,
      questions: updatedQuestions
    });
  };

  const handleQueChange = (e, queInd) => {
    const { name, value } = e.target;
    const updatedQuestions = [...editSchoolExam.questions];
    updatedQuestions[queInd][name] = value;

    setEditSchoolExam({
      ...editSchoolExam,
      questions: updatedQuestions
    });
  };

  // Handle Input of Question Point of a Specific Question
  const handleQuePointChange = (e, queInd) => {
    const { name, value } = e.target;
    const updatedQuestions = [...editSchoolExam.questions];
    updatedQuestions[queInd][name] = value;

    setEditSchoolExam({
      ...editSchoolExam,
      questions: updatedQuestions
    });

    calculateTotalGrade();
  };

  // Handle Question Description of a Specific Question
  const handleQueDescChange = (e, queInd) => {
    const { name, value } = e.target;
    const updatedQuestions = [...editSchoolExam.questions];
    updatedQuestions[queInd][name] = value;

    setEditSchoolExam({
      ...editSchoolExam,
      questions: updatedQuestions
    });
  };

  const getSubjectsForClasses = async (classValues) => {
    try {
      const newSubjects = [...allClassSubject];

      for (const { id: classId, name: className } of classValues) {
        const SUBJECT_ENDPOINT = isTeacher ? TEACHER_SUBJECT_FOR_CLASS_ENDPOINT : CLASS_SUBJECT;
        const res = await httprequest.get(`${SUBJECT_ENDPOINT}${classId}`);
        const classSubjects = res?.data?.data;

        if (isTeacher) {
          // Append class name to each subject for display
          const subjectsWithClassNameTeacher = classSubjects.map((subjects) => ({
            ...subjects,
            displayName: `${subjects?.subject?.name} | ${className}`
          }));

          // This adds only unique subjects from this class to the newSubjects array
          subjectsWithClassNameTeacher.forEach((newSub) => {
            if (!newSubjects.some((sub) => sub?.subject?.id === newSub?.subject?.id)) {
              newSubjects.push(newSub);
            }
          });
        } else {
          // Append class name to each subject for display
          const subjectsWithClassName = classSubjects.map((subject) => ({
            ...subject,
            displayName: `${subject.subject_name} | ${className}`
          }));

          // This adds only unique subjects from this class to the newSubjects array
          subjectsWithClassName.forEach((newSub) => {
            if (!newSubjects.some((sub) => sub?.subject_id === newSub?.subject_id)) {
              newSubjects.push(newSub);
            }
          });
        }
      }

      // Update state with the unique subjects after adding new ones
      setAllClassSubject(newSubjects);
    } catch (err) {
      toast.error(err?.response?.data);
    }
  };

  // Handle Class Change and Get Subject for their respective Classes
  const handleMultipleAccessChange = async (selectedOptions) => {
    // Extract selected class ids and names
    const selectedValues = selectedOptions.map((option) => ({
      id: option?.value,
      name: option?.label
    }));

    // Update selected class IDs in state
    setEditSchoolExam((prevForm) => ({
      ...prevForm,
      class_id: selectedValues
    }));

    // Get IDs of currently selected classes
    const selectedClassIds = selectedValues.map((classObj) => classObj.id);

    // Filter out subjects that no longer match any selected class
    setAllClassSubject((prevSubjects) => prevSubjects.filter((subject) => selectedClassIds.includes(subject.class_id))
    );

    // Find classes that are newly added by checking against the existing subjects
    const existingClassIds = allClassSubject.map((sub) => sub.class_id);
    const newClasses = selectedValues.filter(
      (classObj) => !existingClassIds.includes(classObj.id)
    );

    // Fetch and add subjects only for newly added classes
    if (newClasses.length > 0) {
      getSubjectsForClasses(newClasses);
    }
  };

  // Get An Assignment By ID
  const getEnrolmentExamById = () => {
    setIsLoading(true);
    httprequest.get(`${A_SCHOOL_EXAM}/${id}/${schoolId}`).then((res) => {
      // setAssignmentData(res?.data?.data);
      const data = res?.data?.data;
      setEditSchoolExam({
        ...editSchoolExam, subject_id: data?.subject,
        title: data?.title,
        class_id: data?.classes,
        description: data?.description,
        total_grade: data?.total_grade,
        instruction: data?.instruction,
        questions: data?.questions || [],
        duration: data?.duration,
        status: data?.status
      });
      // setEditdableData(res?.data?.data);
      setIsLoading(false);
    }).catch((err) => {
      toast.error(err?.response?.data);
      setIsLoading(false);
    });
  };

  // Handle Edit an Assignemnt
  const handleEditSchoolExam = () => {
    if (editEnrolExamValidator.allValid()) {
      setIsEditing(true);
      const updatedClassIds = editSchoolExam?.class_id.map((a_class) => a_class?.id);
      const subjectId = editSchoolExam?.subject_id?.id;
      httprequest.patch(`${A_SCHOOL_EXAM}/${id}/${schoolId}`, { ...editSchoolExam, class_id: updatedClassIds, subject_id: subjectId }).then((res) => {
        setIsEditing(false);
        toast.success(res?.data?.message);
        setTimeout(() => {
          navigate(`/schools/${schoolId}`);
        }, 1500);
        getEnrolmentExamById();
      }).catch((err) => {
        setIsEditing(false);
        toast.error(err?.response?.data?.message);
      });
    } else {
      showEditEnrolExamValidator(true);
    }
  };

  const handleDraftExam = () => {
    setIsDraftSaving(true);
    const subjectId = editSchoolExam?.subject_id?.id;
    const updatedClassIds = editSchoolExam?.class_id.map((a_class) => a_class?.id);
    httprequest.patch(`${A_SCHOOL_EXAM}/${id}/${schoolId}`, { ...editSchoolExam, status: "draft", class_id: updatedClassIds, subject_id: subjectId }).then((res) => {
      setIsDraftSaving(false);
      toast.success(res?.data?.message);
      if (isTeacher) {
        navigate("/examinations");
      } else {
        navigate("/school-examination/examination");
      }
      getEnrolmentExamById();
    }).catch((err) => {
      setIsDraftSaving(false);
      showEditEnrolExamValidator(true);
      toast.error(err?.response?.data?.message);
    });
  };

  // Handle Exam Publish
  const handlePublishExam = () => {
    setIsPublishing(true);
    const subjectId = editSchoolExam?.subject_id?.id;
    const updatedClassIds = editSchoolExam?.class_id.map((a_class) => a_class?.id);
    httprequest.patch(`${A_SCHOOL_EXAM}/${id}`, { ...editSchoolExam, status: "published", class_id: updatedClassIds, subject_id: subjectId }).then((res) => {
      setIsPublishing(false);
      toast.success(res?.data?.message);
      if (isTeacher) {
        navigate("/examinations");
      } else {
        navigate("/school-examination/examination");
      }
      getEnrolmentExamById();
    }).catch((err) => {
      setIsPublishing(false);
      showEditEnrolExamValidator(true);
      toast.error(err?.response?.data?.message);
    });
  };

  // --| Remove Additional Question that has been added
  const handleDeleteQuestion = (question_ind) => {
    const allquestions = editSchoolExam?.questions;
    const questionToDelete = allquestions?.find((item) => item?.question_index === question_ind);
    const newQuestions = allquestions?.filter((item) => item?.question_index !== questionToDelete?.question_index);
    setEditSchoolExam((prev) => ({
      ...prev,
      questions: newQuestions
    }));
  };

  const handleIconClick = (queInd) => {
    document.getElementById(`imageInput-${queInd}`).click();
  };

  const handleIconOptionClick = (i, queInd) => {
    document.getElementById(`imageInput-${i}${queInd}`).click();
  };

  // Handle image upload and update the specific question
  const handleQuestionImageChange = async (event, queInd) => {
    if (event?.target?.files?.length > 0) {
      const file = event.target.files[0];

      // Prepare the image for upload
      const formData = new FormData();
      formData.append("file", file);

      try {
        // Upload the image
        const response = await httprequest.post(UPLOAD_ENDPOINT, formData);

        if (response?.status === 200 && response?.data?.data?.[0]?.file_url) {
          const uploadedImageDetails = {
            upload_id: response?.data?.data?.[0]?.upload_id,
            file_url: response?.data?.data?.[0]?.file_url
          };

          // Create a copy of the current question
          const updatedQuestion = {
            ...editSchoolExam?.questions[queInd],
            file: uploadedImageDetails
          };

          // Send only the updated question to the backend
          // await httprequest.patch(`${A_SCHOOL_EXAM}/${id}`, {
          //   ...editSchoolExam,
          //   questions: [updatedQuestion] // This update the modified question
          // });

          // Update local state after successful upload
          setEditSchoolExam((prevForm) => ({
            ...prevForm,
            questions: prevForm.questions.map((question, index) => index === queInd ? updatedQuestion : question
            )
          }));

          toast.success(`Image added to question ${queInd + 1}`);
        } else {
          toast.error(response?.data);
        }
      } catch (error) {
        toast.error(error?.response?.message);
      }
    }
  };

  // Remove a Question Image
  const removeQueImage = (queInd) => {
    // Update editAssignmentForm to remove the image for the specific question without making an API call
    setEditSchoolExam((prevForm) => ({
      ...prevForm,
      questions: prevForm.questions.map((question, index) => index === queInd
        ? {
          ...question,
          file: {}
        }
        : question
      )
    }));
    // Temporarily remove the image preview from the state
    toast.success(`Image removed from question ${queInd + 1}`);
  };

  // Handle Upload Image to an Option
  const handleOptionImageChange = async (event, optionIndex, questionIndex) => {
    if (event?.target?.files?.length > 0) {
      const file = event.target.files[0];

      // Disable the input while the file is being uploaded
      setDisabledInputs((prevDisabled) => ({
        ...prevDisabled,
        [questionIndex]: {
          ...prevDisabled[questionIndex],
          [optionIndex]: true
        }
      }));

      // Prepare to send the image to the upload endpoint
      const formData = new FormData();
      formData.append("file", file);

      try {
        // Upload the image
        const response = await httprequest.post(UPLOAD_ENDPOINT, formData);

        if (response?.status === 200 && response?.data?.data?.[0]?.file_url) {
          const uploadedImageDetails = {
            upload_id: response.data.data[0].upload_id,
            file_url: response.data.data[0].file_url
          };

          // Update only the specific option in the question at questionIndex
          const updatedOptions = editSchoolExam.questions[questionIndex].options.map(
            (option, oIndex) => oIndex === optionIndex ? uploadedImageDetails : option
          );

          const updatedQuestion = {
            ...editSchoolExam.questions[questionIndex],
            options: updatedOptions
          };

          // Update the editSchoolExam state with the modified question
          setEditSchoolExam((prevForm) => ({
            ...prevForm,
            questions: prevForm.questions.map((question, index) => index === questionIndex ? updatedQuestion : question
            )
          }));

          // API call to update only the specific option of the particular question
          // await httprequest.patch(`${A_SCHOOL_EXAM}/${id}`, {
          //   ...editSchoolExam,
          //   questions: [updatedQuestion]
          // });

          toast.success(`Image added to option ${optionIndex + 1} in question ${questionIndex + 1}`);
        } else {
          toast.error(response?.data);
        }
      } catch (error) {
        toast.error(error?.response?.message);
      }
    }
  };

  // Delete an Image of an Option
  const removeOptionImage = (optionIndex, questionIndex) => {
    // Remove the image details from the specific option
    const updatedOptions = editSchoolExam?.questions[questionIndex].options.map(
      (option, oIndex) => oIndex === optionIndex ? { ...option, upload_id: "", file_url: "" } : option
    );
    // Create the updated question object with the modified option
    const updatedQuestion = {
      ...editSchoolExam?.questions[questionIndex],
      options: updatedOptions
    };
    // Update local state after the image is removed
    setEditSchoolExam((prevForm) => ({
      ...prevForm,
      questions: prevForm.questions.map((question, index) => index === questionIndex ? updatedQuestion : question
      )
    }));
    toast.success(`Image removed from option ${optionIndex + 1} in question ${questionIndex + 1}`);
  };

  // --| Get all classes as a school admin
  const getAllAdminClasses = () => {
    httprequest
      .get(`${ADMIN_CLASS_ENDPOINT}/${schoolId}`)
      .then((res) => {
        setClassData(
          res?.data?.data.map((a_class) => ({
            value: a_class?.id,
            label: a_class?.class_name
          }))
        );
      })
      .catch(() => {});
  };

  // This handles the Assignment Description input
  const handleEditEnrolmentExam = (e) => {
    const { name, value } = e.target;

    setEditSchoolExam({ ...editSchoolExam, [name]: value });
  };

  useEffect(() => {
    calculateTotalGrade();
  }, [editSchoolExam?.questions]);

  useEffect(() => {
    if (editSchoolExam?.class_id) {
      getSubjectsForClasses(editSchoolExam?.class_id);
    }
  }, [editSchoolExam?.class_id]);

  useEffect(() => {
    getAllAdminClasses();
    getEnrolmentExamById();
    getSubjectsForClasses();
  }, []);

  const options = [
    // {
    //   value: "paragraph",
    //   text: "Paragraph",
    //   icon: <Icon icon="carbon:text-short-paragraph" width="25" height="25" />
    // },
    {
      value: "multiple_choice",
      text: "Multiple Choice",
      icon: <Icon icon="mdi:radiobox-marked" width="25" height="25" />
    },
    {
      value: "checkbox",
      text: "Checkbox",
      icon: <Icon icon="ci:checkbox-check" width="25" height="25" />
    }
    // {
    //   value: "dropdown",
    //   text: "Dropdown",
    //   icon: <Icon icon="tabler:select" width="25" height="25" />
    // },
    // {
    //   value: "file_upload",
    //   text: "File Upload",
    //   icon: <Icon icon="basil:cloud-upload-outline" width="25" height="25" />
    // },
    // {
    //   value: "date",
    //   text: "Date",
    //   icon: (
    //     <Icon
    //       icon="material-symbols-light:date-range-sharp"
    //       width="25"
    //       height="25"
    //     />
    //   )
    // },
    // {
    //   value: "time",
    //   text: "Time",
    //   icon: <Icon icon="mingcute:time-line" width="25" height="25" />
    // }
  ];

  // const { questions } = editSchoolExam;

  return (
    <Layout
      children={
        <>
          <div className="breadcrumb-container">
            <div>

              <BreadCrumb
                link_one={`/schools/${schoolId}`}
                link_one_name="All School Examination"
                active="Edit an Examination"
                description="Edit a School Examination"
              />
            </div>
            <div className="flex gap-10">
              <Button
                variant="primaryoutline"
                buttonSize="fluid"
                color="btnfontprimary"
                onClick={editSchoolExam?.status === "draft" ? handlePublishExam : handleDraftExam}
                buttonName={editSchoolExam?.status === "draft" ? "Publish Exam" : "Save as Draft"}
                isLoading={editSchoolExam?.status === "draft" ? isPublishing : isDraftSaving}
              />
              <Button
                variant="primary"
                buttonSize="fluid"
                color="btndefault"
                buttonName="Edit School Examination"
                isLoading={isEditing}
                onClick={handleEditSchoolExam}
              />
            </div>
          </div>
          <div className="page-content">
            {isLoading ? (
              <PageLoader />
            ) :
              <>
                <WidgetTitle
                  title="Class Information"
                />
                <div className={`${styles.assignmentsection} margin-bottom-14`}>
                  <Grid container spacing={2}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <div className="multiple-select">
                        <p>Class</p>
                        <Select
                          isMulti
                          name="class_id"
                          closeMenuOnSelect={true}
                          options={classData}
                          onChange={handleMultipleAccessChange}
                          defaultValue={editSchoolExam?.class_id?.map(item => ({ label: item?.name, value: item?.id }))}
                          getOptionLabel={(option) => option.label}
                          getOptionValue={(option) => option.value}
                        />
                      </div>
                      {editEnrolExamValidator.message(
                        "class_id",
                        editSchoolExam?.class_id,
                        "required"
                      )}
                    </Grid>
                    {isTeacher ? (
                      <Grid item lg={4} md={4} sm={6} xs={12}>
                        <SelectGroup
                          label="Select Subject"
                          required
                          children={
                            <select
                              value={editSchoolExam?.subject_id?.id}
                              name="subject_id"
                              onChange={handleEditEnrolmentExam}
                            >
                              <option value="">--- Select ---</option>

                              {allClassSubject?.map((sub) => (
                                <option key={sub?.subject?.id} value={sub?.subject?.id}>
                                  {sub?.displayName}
                                </option>
                              ))}
                            </select>
                          }
                        />
                        {editEnrolExamValidator.message(
                          "subject",
                          editSchoolExam?.subject_id,
                          "required"
                        )}
                      </Grid>
                    ) : (
                      <Grid item lg={4} md={4} sm={6} xs={12}>
                        <SelectGroup
                          label="Select Subject"
                          required
                          children={
                            <select
                              value={editSchoolExam?.subject_id?.id}
                              name="subject_id"
                              onChange={handleEditEnrolmentExam}
                            >
                              <option value="">--- Select ---</option>

                              {allClassSubject?.map((sub) => (
                                <option key={sub?.subject_id} value={sub?.subject_id}>
                                  {sub?.displayName}
                                </option>
                              ))}
                            </select>
                          }
                        />
                        {editEnrolExamValidator.message(
                          "subject",
                          editSchoolExam?.subject_id,
                          "required"
                        )}
                      </Grid>
                    )}
                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <InputGroup
                        label="Duration"
                        margin="normal"
                        inputType="number"
                        inputName="duration"
                        defaultValue={editSchoolExam?.duration}
                        placeHolder="Set Duration in Minutes"
                        onChange={handleEditEnrolmentExam}
                        required
                      />
                      {editEnrolExamValidator.message(
                        "Duration",
                        editSchoolExam?.duration,
                        "required"
                      )}
                    </Grid>
                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <InputGroup
                        label="Total Grade"
                        margin="normal"
                        inputType="number"
                        inputName="total_grade"
                        placeHolder="Set Duration in Minutes"
                        value={totalGrade}
                        disabled
                        onChange={handleEditEnrolmentExam}
                        required
                      />
                      {editEnrolExamValidator.message(
                        "Total Grade",
                        editSchoolExam?.total_grade,
                        "required"
                      )}
                    </Grid>
                  </Grid>
                </div>
                <div className={`${styles.assignmentsection} margin-bottom-14`}>
                  <Grid container spacing={2}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <InputGroup
                        label="Examination Title"
                        margin="normal"
                        inputType="text"
                        defaultValue={editSchoolExam?.title}
                        inputName="title"
                        onChange={handleEditEnrolmentExam}
                        required
                      />
                      {editEnrolExamValidator.message(
                        "title",
                        editSchoolExam?.title,
                        "required"
                      )}
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <div className={styles.inputmargin}>
                        <TextAreaGroup
                          label="Examiantion Instruction"
                          inputName="instruction"
                          margin="normal"
                          defaultValue={editSchoolExam?.instruction}
                          placeholder=""
                          onChange={handleEditEnrolmentExam}
                        />
                      </div>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <div className={styles.inputmargin}>
                        <TextAreaGroup
                          label="Description"
                          inputName="description"
                          defaultValue={editSchoolExam?.description}
                          margin="normal"
                          placeholder=""
                          onChange={handleEditEnrolmentExam}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </div>
                <div className={styles.assignmentsection}>
                  <Grid container spacing={2}>
                    {editSchoolExam?.questions?.map((question, queInd) => (
                      <>
                        <Grid item lg={12} md={12} sm={12} xs={12} key={queInd}>
                          <div className={styles.quesaction}>
                            <label className={styles.enterque}> Question {queInd + 1}<span className="input-required"> *</span></label>
                            <div>
                              {editSchoolExam?.questions?.length > 1 ? (
                                <>
                                  <Icon
                                    icon="material-symbols:delete-outline"
                                    width="20"
                                    height="20"
                                    className="delete-icon"
                                    onClick={() => handleDeleteQuestion(question?.question_index, queInd)}
                                  />
                                </>
                              ) : null}
                            </div>
                          </div>
                          <div className={styles.textandimgmain}>
                            <div className={styles.textandimg}>
                              <input
                                type="text"
                                placeholder="Type Question"
                                name="question"
                                value={question?.question}
                                onChange={(e) => {
                                  handleQueChange(e, queInd);
                                }}
                              />
                              {editEnrolExamValidator.message(
                                `Question ${queInd + 1}`,
                                editSchoolExam?.questions[queInd]?.question,
                                "required"
                              )}
                              <div onClick={() => handleIconClick(queInd)} className={styles.queimg}>
                                <Icon icon="basil:image-outline" width="20" height="20" style={{ color: "#858585" }} />
                                <input
                                  type="file"
                                  accept="image/*"
                                  id={`imageInput-${queInd}`}
                                  multiple
                                  onChange={(e) => handleQuestionImageChange(e, queInd)}
                                  style={{ display: "none" }}
                                />
                              </div>
                              {/* Image preview */}
                              <div className={styles.preiewcont}>
                                {editSchoolExam?.questions[queInd]?.file?.file_url && (
                                  <>
                                    <img
                                      src={editSchoolExam?.questions[queInd]?.file?.file_url}
                                      alt={`Selected for question ${queInd + 1}`}
                                    />
                                    <Icon
                                      icon="material-symbols:delete-outline"
                                      width="20"
                                      height="20"
                                      className="delete-icon"
                                      onClick={() => removeQueImage(queInd)}
                                    />
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </Grid>
                        {/* For Question Description */}
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          {"description" in question ? (
                            <div className="margin-top full-width">
                              <div className=" flex gap-10 justify-items-space">
                                <label className={styles.enterque}>Question Description</label>
                                <div>
                                  <div
                                    className="delete-icon"
                                    onClick={() => removeQueDescription(queInd)}
                                  >
                                    <Icon
                                      icon="ooui:close"
                                      width="20"
                                      height="20"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className={styles.textandimgmain}>
                                <div className={styles.textandimg}>
                                  <input
                                    type="text"
                                    placeHolder="Enter Description"
                                    name="description"
                                    value={question?.description}
                                    onChange={(e) => handleQueDescChange(e, queInd)}
                                  />
                                  <></>
                                  <div onClick={handleIconClick} className={styles.queimg}>
                                    <Icon icon="basil:image-outline" width="20" height="20" style={{ color: "#858585" }} />
                                    <input
                                      type="file"
                                      accept="image/*"
                                      id="imageInput"
                                      multiple
                                      disabled
                                      onChange={handleOptionImageChange}
                                      style={{ display: "none" }}
                                    />
                                  </div>
                                  {/* Image preview */}
                                  {/* <div className={styles.preiewoptioncont}>
                                    {optionimages.map((optionimage, index) => (
                                      <img
                                        key={index}
                                        src={optionimage}
                                        alt={`Selected ${index}`}
                                      />
                                    ))}
                                  </div> */}
                                </div>
                              </div>
                              {/* <div className="width-full">
                                <InputGroup
                                  label="Question Description"
                                  margin="normal"
                                  placeHolder="Enter Description"
                                  inputType="text"
                                  value={question?.description}
                                  inputName="description"
                                  onChange={(e) => handleQueDescChange(e, queInd)}
                                />
                              </div> */}
                            </div>
                          ) : null}
                        </Grid>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                          <InputGroup
                            className={styles.pointsInput}
                            label="Question Point"
                            inputType="number"
                            inputMin={1}
                            inputName="grade_point"
                            placeHolder="Enter Question Points"
                            value={question?.grade_point}
                            onChange={(e) => {
                              handleQuePointChange(e, queInd);
                            }}
                          />
                          {editEnrolExamValidator.message(
                            `Question ${queInd + 1} Grade Point`,
                            editSchoolExam?.questions[queInd]?.grade_point,
                            "required"
                          )}
                        </Grid>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                          <SelectGroup
                            label="Add Answer Type"
                            required
                            children={
                              <select
                                name="type"
                                value={question?.type}
                                onChange={(e) => handleQueTypeChange(e, queInd)}
                              >
                                <option value="">--- Select ---</option>
                                {options?.map((label) => {
                                  return (
                                    <option
                                      key={label?.key}
                                      value={label?.value}
                                    >
                                      <Icon
                                        className={`${styles.add_question_color}`}
                                        icon="flat-color-icons:plus"
                                        width="24"
                                        height="24"
                                      />
                                      {label?.text}
                                    </option>
                                  );
                                })}
                              </select>
                            }
                          />
                          {editEnrolExamValidator.message(
                            `Question ${queInd + 1}Question Type`,
                            editSchoolExam?.questions[queInd]?.type,
                            "required"
                          )}
                        </Grid>
                        {/* Checkbox */}
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          {question?.type === "checkbox" ? (
                            <>
                              <Grid container spacing={2} mt={1}>
                                {question?.options?.map((checkbox, i) => {
                                  return (
                                    <Grid
                                      item
                                      lg={6}
                                      md={6}
                                      sm={12}
                                      xs={12}
                                      key={i + 1}
                                    >
                                      <div>
                                        <div className=" flex gap-10 justify-items-space">
                                          <label className={styles.enterque}>Option {i + 1}<span className="input-required"> *</span></label>
                                          {/* if checkbox option is more thatn 1, show close*/}
                                          {question?.options?.length > 1 ? (
                                            <Icon
                                              onClick={() => {
                                                removeAdditionalChoice(i, queInd);
                                              }}
                                              className="delete-icon"
                                              icon="ooui:close"
                                              width="20"
                                              height="20"
                                            />
                                          ) : null}
                                        </div>
                                        <div className={styles.textandimgmain}>
                                          <div className={styles.textandimg}>
                                            <input
                                              type="text"
                                              placeholder="Enter option"
                                              name="question"
                                              value={checkbox?.file_url ? "" : checkbox}
                                              disabled={checkbox?.file_url || disabledInputs[queInd]?.[i]}
                                              onChange={(e) => handleMultipleChoiceChange(e, i, queInd)}
                                            />
                                            {/* {que?.type === "paragraph" ? (
                                              <div className={styles.inputmargin}>
                                                <TextAreaGroup
                                                  margin="normal"
                                                  placeholder=""
                                                // disabled
                                                />
                                              </div>
                                            ) : null} */}
                                            <></>
                                            <div onClick={() => handleIconOptionClick(i, queInd)} className={styles.queimg}>
                                              <Icon icon="basil:image-outline" width="20" height="20" style={{ color: "#858585" }} />
                                              <input
                                                type="file"
                                                accept="image/*"
                                                id={`imageInput-${i}${queInd}`}
                                                // multiple
                                                onChange={(e) => handleOptionImageChange(e, i, queInd)}
                                                style={{ display: "none" }}
                                              />
                                            </div>
                                            {/* Image preview */}
                                            <div className={styles.preiewoptioncont}>
                                              {checkbox?.file_url && (
                                                <>
                                                  <img
                                                    src={checkbox.file_url}
                                                    alt={`Option ${i + 1}`}
                                                  />
                                                  <Icon
                                                    icon="material-symbols:delete-outline"
                                                    width="20"
                                                    height="20"
                                                    className="delete-icon"
                                                    onClick={() => removeOptionImage(i, queInd)}
                                                  />
                                                </>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                        {editEnrolExamValidator.message(
                                          `Option ${i + 1}`,
                                          editSchoolExam?.questions[queInd]?.options[i],
                                          "required"
                                        )}
                                        <div className="text-align-left">
                                          <div
                                            className="flex gap-10 align-items-center justify-items-space margin-top-5 "
                                          >
                                            <div className={styles.correctcontainer}>
                                              <input
                                                type="checkbox"
                                                name="answer"
                                                value={i}
                                                id={`correct-${queInd}-${i}`}
                                                defaultChecked={editSchoolExam?.questions[queInd]?.answer?.includes(i)}
                                                onChange={(e) => handleCorrectChoiceChange(e, i, queInd)}
                                              />
                                              <label
                                                className={styles.correctlabel}
                                                htmlFor={`correct-${queInd}-${i}`}
                                              >
                                              is correct
                                              </label>
                                            </div>
                                          </div>
                                          {editEnrolExamValidator.message(
                                            `question ${queInd + 1} answer`,
                                            editSchoolExam?.questions[queInd]["answer"].length > 0 ? editSchoolExam?.questions[queInd] : null,
                                            "required"
                                          )}
                                        </div>
                                      </div>
                                    </Grid>
                                  );
                                })}
                              </Grid>
                              <div
                                className={styles.addoption}
                                onClick={() => handleAdditionalOptions(queInd)}
                              >
                                <Icon
                                  icon="octicon:feed-plus-16"
                                  width="14"
                                  height="14"
                                />
                                <p>Add another checkbox</p>
                              </div>
                            </>
                          ) :
                            <>
                              {/* Type === multiple choice */}
                              <Grid container spacing={2} mt={1}>
                                {question?.options?.map((radio, i) => {
                                  return (
                                    <Grid
                                      item
                                      lg={6}
                                      md={6}
                                      sm={12}
                                      xs={12}
                                      key={i + 1}
                                    >
                                      <div>
                                        <div className=" flex gap-10 justify-items-space">
                                          <label className={styles.enterque}>Option {i + 1} <span className="input-required"> * </span></label>
                                          {/* if checkbox option is more thatn 1, show close*/}
                                          {question?.options?.length > 1 ? (
                                            <Icon
                                              onClick={() => {
                                                removeAdditionalChoice(i, queInd);
                                              }}
                                              className="delete-icon"
                                              icon="ooui:close"
                                              width="20"
                                              height="20"
                                            />
                                          ) : null}
                                        </div>
                                        <div className={styles.textandimgmain}>
                                          <div className={styles.textandimg}>
                                            <input
                                              type="text"
                                              placeholder="Enter option"
                                              name="question"
                                              disabled={radio?.file_url || disabledInputs[queInd]?.[i]}
                                              value={radio?.file_url ? "" : radio}
                                              onChange={(e) => handleMultipleChoiceChange(e, i, queInd)}
                                            />
                                            <></>
                                            <div onClick={() => handleIconOptionClick(i, queInd)} className={styles.queimg}>
                                              <Icon icon="basil:image-outline" width="20" height="20" style={{ color: "#858585" }} />
                                              <input
                                                type="file"
                                                accept="image/*"
                                                id={`imageInput-${i}${queInd}`}
                                                // multiple
                                                onChange={(e) => handleOptionImageChange(e, i, queInd)}
                                                style={{ display: "none" }}
                                              />
                                            </div>
                                            {/* Image preview */}
                                            <div className={styles.preiewoptioncont}>
                                              {radio?.file_url && (
                                                <>
                                                  <img
                                                    src={radio.file_url}
                                                    alt={`Option ${i + 1}`}
                                                  />
                                                  <Icon
                                                    icon="material-symbols:delete-outline"
                                                    width="20"
                                                    height="20"
                                                    className="delete-icon"
                                                    onClick={() => removeOptionImage(i, queInd)}
                                                  />
                                                </>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                        {editEnrolExamValidator.message(
                                          `Option ${i + 1}`,
                                          editSchoolExam?.questions[queInd]?.options[i],
                                          "required"
                                        )}
                                        <div className="text-align-left">
                                          <div
                                            className="flex gap-10 align-items-center justify-items-space margin-top-5 "
                                          >
                                            <div className={styles.correctcontainer}>
                                              <input
                                                type="radio"
                                                name={`answer-${queInd}`}
                                                value={i}
                                                id={`correct-${queInd}-${i}`}
                                                defaultChecked={editSchoolExam?.questions[queInd]?.answer?.includes(i)}
                                                onChange={(e) => handleCorrectChoiceChange(e, i, queInd)}
                                              />
                                              <label
                                                className={styles.correctlabel}
                                                htmlFor={`correct-${queInd}-${i}`}
                                              >
                                          is correct
                                              </label>
                                            </div>
                                          </div>
                                          {editEnrolExamValidator.message(
                                            `question ${queInd + 1} answer`,
                                            editSchoolExam?.questions[queInd]["answer"].length > 0 ? editSchoolExam?.questions[queInd] : null,
                                            "required"
                                          )}
                                        </div>
                                      </div>
                                    </Grid>
                                  );
                                })}
                              </Grid>
                              <div
                                className={styles.addoption}
                                onClick={() => handleAdditionalOptions(queInd)}
                              >
                                <Icon
                                  icon="octicon:feed-plus-16"
                                  width="14"
                                  height="14"
                                />
                                <p>Add another option</p>
                              </div>
                            </>}
                        </Grid>
                        <div className={styles.editquestionfooter}>
                          <div className="flex gap-10 align-items-center justifyRight">
                            {/* Conditionally render the IconButton only if there is no description */}
                            {!question?.description && (
                              <IconButton
                                aria-label="more"
                                id="long-button"
                                aria-controls={open ? "long-menu" : null}
                                aria-expanded={open ? "true" : null}
                                aria-haspopup="true"
                                onClick={(e) => handleClick(e, queInd)}
                              >
                                <Icon
                                  icon="radix-icons:dots-vertical"
                                  width="20"
                                  height="20"
                                />
                                <label className={styles.enterque}>More</label>
                              </IconButton>
                            )}
                          </div>
                        </div>
                        <Menu
                          id="basic-menu"
                          MenuListProps={{
                            "aria-labelledby": "basic-button"
                          }}
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleAdditionalQueClose}
                        >
                          <MenuItem
                            onClick={() => {
                              toggleQueDescriptionTrue();
                              handleAdditionalQueClose();
                            }}
                          >
                          Add Description on Question
                          </MenuItem>
                        </Menu>
                      </>
                    ))}
                  </Grid>
                  <div
                    className={styles.addque}
                  >
                    <Icon icon="octicon:feed-plus-16" width="16" height="16" />
                    <p onClick={handleAdditionalQuestion}>Add question</p>
                  </div>
                  <div className={styles.btnwrapper}>
                    <Button
                      variant="primaryoutline"
                      buttonSize={isSmallScreen ? "full" : "fluid"}
                      color="btnfontprimary"
                      onClick={editSchoolExam?.status === "draft" ? handlePublishExam : handleDraftExam}
                      buttonName={editSchoolExam?.status === "draft" ? "Publish Exam" : "Save as Draft"}
                      isLoading={editSchoolExam?.status === "draft" ? isPublishing : isDraftSaving}
                    />
                    <Button
                      variant="primary"
                      buttonSize={isSmallScreen ? "full" : "fluid"}
                      color="btndefault"
                      buttonName="Edit School Examination"
                      isLoading={isEditing}
                      onClick={handleEditSchoolExam}
                    />
                  </div>
                </div>
              </>
            }
          </div>
          <ToastContainer />
        </>
      }
    />
  );
};

export default EditSchoolExam;
